import React, { useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { observer } from 'mobx-react-lite';

import useStores from '../../stores/useStores';
import './layout.sass';

function LayoutContent({ children = null, panel, style = {} }) {
  const { uiStore } = useStores();

  useEffect(() => {
    uiStore.setIsContentVisible(!!children);
  }, [children]);

  return (
    <>
      {panel}
      <TransitionGroup component={null}>
        {children && (
          <CSSTransition
            key={location.key}
            classNames="slide"
            in={!children}
            timeout={{ enter: 300, exit: 500 }}
          >
            <div style={style} className="layout--content">
              {children}
            </div>
          </CSSTransition>
        )}
      </TransitionGroup>
    </>
  );
}

export default observer(LayoutContent);
